import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fill-height"},[_c(VRow,[_c(VCol,{attrs:{"cols":"12"}},[_c(VBreadcrumbs,{staticClass:"ml-10 pl-0 pt-0 mt-3",attrs:{"items":_vm.breadcrumbsItems,"divider":"/"}})],1)],1),_c(VRow,{staticClass:"fill-height px-8 mt-1",attrs:{"no-gutters":""}},[_c(VCol,{attrs:{"cols":"12"}},[_c('router-view',{attrs:{"network":_vm.network,"address":_vm.address}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }